window.dtIdleReport = function () {
  setSessionValue()

  var idle_report_datatable = new DataTable('#idle-reports-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#idle-reports-datatable').data('source'),
      data: function (d) {
        d.begin_date = $("#datatable-filter-begin-date").val()
        d.end_date = $("#datatable-filter-end-date").val()
        d.line_id = $("#datatable-filter-line").val()
      },
      beforeSend: function () { showLoadingRow('#idle-reports-datatable', 8); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "action" },
      { "data": "start" },
      { "data": "stop" },
      { "data": "line" },
      { "data": "idle" },
      { "data": "remarks" },
    ],
    columnDefs: [
      {
        targets: [2, 3, -1],
        className: 'text-nowrap'
      }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    }
  });

  $(document).off("change", "#datatable-filter-begin-date, #datatable-filter-end-date")
  $(document).on("change", "#datatable-filter-begin-date, #datatable-filter-end-date", function () {
    $("#datatable-filter-content").html("")
    $("#datatable-filter-content").attr("hidden", "hidden")
    idle_report_datatable.ajax.reload()
  })

  $(document).off("change", "#datatable-filter-line")
  $(document).on("change", "#datatable-filter-line", function () {
    idle_report_datatable.ajax.reload()
  })

  dtFinalTouch()
}